import {useCallback} from "react";
import {useSelector} from "react-redux";
import {getPermission} from "../redux/appEnvironment.selector";
import {PermissionsEnum} from "../redux/models/appEnvironment";

export enum AdminCategory {
  "users" = "users",
  "user" = "user",
  "workspace" = "workspace",
  "workspaces" = "workspaces",
  "datamodels" = "datamodels",
  "datamodel" = "datamodel",
  "exports" = "exports",
  "periods" = "periods"
}

export const useGetAdminAccess = () => {
  const getPermissionSelector = useSelector(getPermission)

  const isAdmin = getPermissionSelector(PermissionsEnum.userCanManageOnEnvironment)
  const isManager = getPermissionSelector(PermissionsEnum.workspaceCanEditProtectedContent)
  const isSuperAdmin = getPermissionSelector(PermissionsEnum.userCanManageAdvancedFeature)

  return useCallback((category: AdminCategory) => {
    switch(category) {
      case AdminCategory.users:
        return isAdmin || isSuperAdmin
      case AdminCategory.user:
        return isAdmin || isSuperAdmin
      case AdminCategory.workspace:
        return isAdmin || isSuperAdmin || isManager
      case AdminCategory.workspaces:
        return isAdmin || isSuperAdmin
      case AdminCategory.datamodel:
        return isAdmin || isSuperAdmin
      case AdminCategory.datamodels:
        return isAdmin || isSuperAdmin
      case AdminCategory.exports:
        return isSuperAdmin
      case AdminCategory.periods:
        return isSuperAdmin
      default:
        return false
    }
  }, [isAdmin, isManager, isSuperAdmin])
}